// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2H0Ea","detailsBorder":"styles_detailsBorder__1xbXl"};